{
  "loading": "Loading project…",
  "load_error_title": "Couldn't load the board",
  "load_error_message": "Something went wrong loading this project. Check your connection and try again.",
  "retry": "Retry",
  "private_team_title": "Only members of the {dept} team",
  "private_project_title": "Only explicit members can see this project",
  "private_label": "Private",
  "no_description": "No description",
  "members_count_title_one": "{n} explicit member",
  "members_count_title_other": "{n} explicit members",
  "add_members_title": "Add members to the project",
  "members": "Members",
  "ai_summary_title": "Executive summary with AI",
  "ai_summary": "AI summary",
  "record_meeting_title": "Record meeting for this project",
  "record_meeting": "Record meeting",
  "confirm_delete_column_title": "Delete the column \"{name}\"?",
  "confirm_delete_column_message": "Tasks in this column will be moved to \"{destination}\". Other columns: {remaining}.",
  "confirm_delete_column_action": "Delete column",
  "error_delete_column": "Couldn't delete the column.",
  "confirm_delete_board_title": "Delete the board \"{name}\"?",
  "confirm_delete_board_message": "The board and all of its columns and tasks will be deleted. This action can't be undone.",
  "confirm_delete_board_action": "Delete board",
  "error_delete_board": "Couldn't delete the board.",
  "linked_section": "Linked",
  "board_menu": {
    "button": "More",
    "title": "More board actions",
    "public_tickets": "Public tickets",
    "rename": "Rename",
    "delete": "Delete board",
    "schedule": "Duration and owner",
    "share": "Copy board link"
  },
  "rename": {
    "title": "Rename board",
    "label": "Board name",
    "placeholder": "Board name",
    "save": "Save",
    "saving": "Saving…",
    "error": "Couldn't rename the board."
  },
  "move": {
    "button": "Move to team",
    "title": "Move project to another team",
    "description": "Pick the team to move \"{name}\" to. Its sections and tasks move with it; the department and any members not in the destination team are removed.",
    "no_teams": "You have no other teams where you're an owner or admin.",
    "error": "Couldn't move the project.",
    "cancel": "Cancel",
    "confirm": "Move",
    "moving": "Moving…"
  },
  "import": {
    "button": "Import",
    "button_title": "Import tasks from a Planner Excel file",
    "title": "Import tasks from Planner",
    "help": "Upload the Excel file exported from Microsoft Planner (\"Export plan to Excel\"). Each row becomes a task and buckets become board columns.",
    "pick_file": "Click to choose the file (.xlsx, .xls or .csv)",
    "cancel": "Cancel",
    "submit": "Import",
    "importing": "Importing…",
    "error_generic": "The file could not be imported.",
    "done_count": "Imported {n} task(s).",
    "sections_created": "Created {n} new column(s).",
    "skipped": "Skipped {n} row(s) without a name.",
    "limit_reached": "Your plan's task limit was reached; not all tasks were imported.",
    "unmatched": "Assignees not found in the team: {names}.",
    "finish": "Done"
  },
  "report": {
    "button": "Report",
    "button_title": "Generate a project report",
    "title": "Project report",
    "description": "Generate a PDF with the status of the tasks in \"{name}\". Optionally filter by date range.",
    "presets": {
      "this_month": "This month",
      "last_30": "Last 30 days",
      "this_year": "This year",
      "clear": "No filter"
    },
    "from": "From",
    "to": "To",
    "hint": "If you don't pick dates, the last 7 days are used.",
    "range_error": "The \"From\" date can't be later than the \"To\" date.",
    "error": "Couldn't generate the report.",
    "cancel": "Cancel",
    "generate": "Generate PDF",
    "generating": "Generating…"
  },
  "error_reorder_columns": "Couldn't reorder the columns.",
  "filters": {
    "button": "Filters",
    "title": "Filter tasks",
    "active_one": "1 filter",
    "active_other": "{n} filters",
    "tags_label": "By tag",
    "assignees_label": "By assignee",
    "no_tags": "This project has no tasks with tags.",
    "no_assignees": "This project has no tasks with assignees.",
    "clear": "Clear filters",
    "empty_result": "No task matches the filters."
  },
  "health": {
    "label": "Status",
    "none": "No status",
    "on_track": "On track",
    "at_risk": "At risk",
    "off_track": "Off track",
    "panel_title": "Project status",
    "body_placeholder": "How is the project going? (optional)",
    "publish": "Publish update",
    "publishing": "Publishing…",
    "history_empty": "No status updates yet.",
    "posted": "Status published",
    "badge_title": "View and publish project status"
  },
  "pending_tickets_title": "Pending requests received via the public link",
  "pending_tickets_count": "{n} request | {n} requests",
  "schedule": {
    "title": "Duration and owner",
    "description": "Set how long the project is expected to take and who follows up on it.",
    "start_date": "Start date",
    "end_date": "End date",
    "invalid_range": "The end date can't be earlier than the start date.",
    "duration_days": "{n} estimated day | {n} estimated days",
    "since": "From {date}",
    "until": "Until {date}",
    "owner": "Direct owner",
    "owner_none": "No owner",
    "owner_help": "The main point of contact and the person tracking progress.",
    "owner_title": "Owner: {name}",
    "save": "Save",
    "saving": "Saving…",
    "cancel": "Cancel",
    "error": "Couldn't save the duration and owner."
  }
}
